import { ModalProps, withModalConditionalRender } from '@billy/design-system'
import { ReactElement } from 'react'

import { PaymentMethodsFormContextProvider } from './context/PaymentMethodsFormContext'
import { PaymentMethodsModalComponent } from './elements/PaymentMethodsModalComponent'

interface PaymentMethodsModalProps extends ModalProps {
  onSubmit?: () => void
}

const PaymentMethods = ({ onSubmit, ...modalProps }: PaymentMethodsModalProps): ReactElement => {
  return (
    <PaymentMethodsFormContextProvider id={modalProps.id} onSubmit={onSubmit}>
      <PaymentMethodsModalComponent {...modalProps} />
    </PaymentMethodsFormContextProvider>
  )
}

export const PaymentMethodsModal = withModalConditionalRender(PaymentMethods)
